import 'scss/solutions/dialogue-analysis.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/dialogue-analysis.js